export default __webpack_public_path__ + "static/media/customer-login@2x.e4f71539.png";